<template>
    <div class="automation-templates-layout">
        <header class="automation-templates-layout__header">
            <slot name="header" />
        </header>
        <div class="automation-templates-layout__container">
            <aside class="automation-templates-layout__sidebar">
                <slot name="sidebar" />
            </aside>

            <main class="automation-templates-layout__main-content">
                <slot />
            </main>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AutomationTemplatesLayout',
};
</script>

<style lang="scss">
.global:has(.automation-templates-layout) {
    // Overwrite global styles SAAS background for the automation templates layout (gray to white)
    background-color: var(--colors-common-background-default);
}
</style>
<style lang="scss" scoped>
.automation-templates-layout {
    &__header {
        display: flex;
        align-items: center;
    }
    &__container {
        position: relative;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        column-gap: 24px;

        @media (min-width: 1440px) {
            max-width: 1328px;
            margin: 0 auto;
        }

        @media (min-width: 1920px) {
            max-width: 1376px;
        }
    }
    &__sidebar {
        grid-column: 1 / 4;
    }
    &__main-content {
        grid-column: 4 / 13;

        @media (min-width: 1280px) {
            grid-column: 5 / 12;
        }

        @media (min-width: 1440px) {
            grid-column: 5 / 11;
        }
    }
}
</style>
